// src/admin/components/AdminLoading.tsx
import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

type Props = { open: boolean };

const AdminLoading: React.FC<Props> = ({ open }) => (
  <Backdrop open={open} sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
    <CircularProgress />
  </Backdrop>
);

export default AdminLoading;
